import moment from 'moment-tz';

import type {ReviewDateState} from 'app/review/types';

export const getReviewDateStatus = (
  reviewDate: string,
  reminderInterval: string
): ReviewDateState => {
  const now = moment();

  if (now.isAfter(reviewDate)) {
    return 'overdue';
  }

  if (now.isAfter(iso8601ToMoment(reminderInterval, 'subtract', reviewDate))) {
    return 'reminder_time';
  }

  return 'ok';
};

export const iso8601ToMoment = (
  duration: string,
  method: 'add' | 'subtract', // returns `start` (or `now`) modified by the given iso8601 format duration.
  start?: string
) => moment(start)[method](moment.duration(duration));

export const getNextReviewDate = (
  duration: string,
  hour: number,
  tz: string
) => {
  const reviewDate = iso8601ToMoment(duration, 'add').tz(tz);
  return reviewDate.clone().startOf('day').hour(hour).toISOString();
};
